import React, { useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const LinearProgressBarWithLabel = ({ value, width }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval;

    // Start incrementing progress only if value is greater than 0
    if (value > 0) {
      interval = setInterval(() => {
        setProgress((prev) => {
          const nextValue = prev + 5;

          if (nextValue >= value) {
            clearInterval(interval);
            return value; // Stop at target value
          }

          return nextValue;
        });
      }, 300); // Adjust speed here if needed
    } else {
      // If value is 0 or less, just set progress to 0
      setProgress(0);
    }

    // Cleanup
    return () => clearInterval(interval);
  }, [value]);

  return (
    <div style={{ width: width || '100%' }}>
      {/* Display percentage */}
      <span className="progress-bar-percentage">
        ({Math.round(progress)}%)
      </span>

      <LinearProgress variant="determinate" value={progress} />
    </div>
  );
};

export default LinearProgressBarWithLabel;
